export { objectsMatch, objectsMatchDebug, diffObjects } from '@iotv/iotv-v3-types'

export const listsEquivalent = (listone: any[], listtwo: any[], itemsMatchFn?: (i1: any, i2: any) => boolean) => {
  if (listone.length !== listtwo.length) return false

  for (const i in listone) {
    if (!listtwo.find((i2) => (itemsMatchFn ? itemsMatchFn(i, i2) : i === i2))) return false
  }

  return true
}
